import React from 'react'
import './AddMoney.scss'
import {withRouter} from "react-router-dom";
import BottomNav from "../../component/BottomNav/BottomNav";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import WalletTransactionHistoryQuery from "../../queries/WalletTransactionHistoryQuery";
import WalletTransactionHistoryByBalanceTypeQuery from "../../queries/WalletTransactionHistoryByBalanceTypeQuery";
import Loading from "../../component/Loading";
import {Fade, Zoom} from 'react-reveal'
import ReactTimeAgo from 'react-time-ago'
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";

const clock = assetUrl+'images/clock.svg'


class WalletHistory extends React.Component {
	state = {
		activeTab: "all",
		history_list: [],
		loading: false
	}

	handleTabToggle = (tag) => {
		this.setState({
			activeTab: tag
		}, () => {
			this.checkSelectedTag();
		})
	}

	componentDidMount() {
		this.checkSelectedTag();
	}

	checkSelectedTag = () => {
		if (this.state.activeTab === "all") {
			this.getAllHistory();
		} else if (this.state.activeTab === "deposit") {
			this.getHistoryByBalanceType("Deposit_Cash")
		} else if (this.state.activeTab === "winning") {
			this.getHistoryByBalanceType("Winning_Cash")
		} else if (this.state.activeTab === "grant") {
			this.getHistoryByBalanceType("Grant_Cash")
		}
	}

	getAllHistory = () => {
		let variables = {}
		this.setState({
			loading: true
		})
		fetchQuery(environment, WalletTransactionHistoryQuery, variables)
			.toPromise()
			.then(response => {
				this.setState({
					loading: false
				})
				if (response.walletTransactionsFilter !== null
					&& response.walletTransactionsFilter.edges.length > 0
				) {
					this.setState({
						history_list: response.walletTransactionsFilter.edges
					})
				} else {
					this.setState({
						history_list: [],
					})
				}
			}, err => {
				console.log(err);
				this.setState({
					history_list: [],
					loading: false
				})
			});

	}

	getHistoryByBalanceType = (balance_type) => {
		let variables = {
			balanceType: balance_type
		}
		this.setState({
			loading: true
		})
		fetchQuery(environment, WalletTransactionHistoryByBalanceTypeQuery, variables)
			.toPromise()
			.then(response => {
				this.setState({
					loading: false
				})
				if (response.walletTransactionsFilter !== null && response.walletTransactionsFilter.edges.length > 0) {
					this.setState({
						history_list: response.walletTransactionsFilter.edges
					})
				} else {
					this.setState({
						history_list: [],
					})
				}
			}, err => {
				console.log(err);
				this.setState({
					history_list: [],
					loading: false
				})
			});

	}

	render() {
		const {activeTab} = this.state;
		return (
			<Loading loading={this.state.loading}>
				<div className={"wallet-history-component"}>
					{/*<MDBContainer className={"py-2"}>*/}
					{/*    <SubPageHeader title={"Wallet History"} show_action={false}/>*/}
					<TopNavSubpage heading={"Transaction History"} wallet={false} notify={false}/>
					{/*</MDBContainer>*/}
					{/*<hr style={{marginTop: 0, }}/>*/}
					<div style={{overflow: "auto"}}>
						{/*tab*/}
						<div className={"wallet-history-tab-main d-flex"}>
							<div onClick={() => this.handleTabToggle("all")}
							     className={activeTab === "all" ? "wallet-history-tabWrap-active mx-4" : "wallet-history-tabWrap mx-4"}>
								<p className={"wallet-history-tab-text my-1 mr-1 "}>All</p>
								{
									activeTab === "all" && <hr className={"wallet-history-tab-underline mt-0 mb-1"}/>
								}

							</div>
							<div onClick={() => this.handleTabToggle("deposit")}
							     className={activeTab === "deposit" ? "wallet-history-tabWrap-active mx-4" : "wallet-history-tabWrap mx-4"}>
								<p className={"wallet-history-tab-text my-1 mr-1"}>Deposit </p>
								{activeTab === "deposit" && <hr className={"wallet-history-tab-underline mt-0 mb-1"}/>}

							</div>
							<div onClick={() => this.handleTabToggle("winning")}
							     className={activeTab === "winning" ? "wallet-history-tabWrap-active mx-4" : "wallet-history-tabWrap mx-4"}>
								<p className={"wallet-history-tab-text my-1 mr-1"}>Earnings </p>
								{
									activeTab === "winning" &&
									<hr className={"wallet-history-tab-underline mt-0 mb-1"}/>
								}

							</div>
							<div onClick={() => this.handleTabToggle("grant")}
							     className={activeTab === "grant" ? "wallet-history-tabWrap-active mx-4" : "wallet-history-tabWrap mx-4"}>
								<p className={"wallet-history-tab-text my-1 mr-1"}>Bonus </p>
								{
									activeTab === "grant" && <hr className={"wallet-history-tab-underline mt-0 mb-1"}/>
								}

							</div>
						</div>
					</div>
					<div style={{overflowY: "scroll", marginBottom: "120px"}}>
						{
							this.state.loading ?
								<div className={"p-3"}>
									<Skeleton count={8} width={"100%"} height={"60px"} style={{marginBottom:"8px"}}/>
								</div>
								:
							this.state.history_list.length > 0 ? this.state.history_list.map((item, index) => {
								let tmp_cash_type = "";
								if (item.node.cashType === "GRANT_MONEY") {
									tmp_cash_type = "Bonus";
								} else if (item.node.cashType === "WINNING_CASH") {
									tmp_cash_type = "Winning Cash";
								} else if (item.node.cashType === "TOP_UP") {
									tmp_cash_type = "Deposit Cash";
								}
								return (
									<div className="wallet-cash-Details" key={index}>
										<Fade bottom>
											<div className="wallet-cash-Details-item  d-flex justify-content-between">
												<div className="d-flex align-items-center">
													<div>
														<p className="wallet-cash-Details-month_text my-1 ">{item.node.transactionType}</p>
														<p className="wallet-cash-Details-refrence_text my-1 ">
															{item.node.transactionType === "DEBIT" ? "Debited from" : "Credited to"}  {tmp_cash_type}
														</p>
													</div>
												</div>
												<div>
													<p
														className="wallet-cash-Details-value_number my-1 text-right"
														style={{color: item.node.transactionType === "DEBIT" ? "#FF5C5C" : "#0AC09E"}}
													>
														₹ {item.node.amount}
													</p>
													<p className="wallet-cash-Details-value_number_text my-1">
														<img src={clock}
														     alt="Italian Trulli"
														     className="wallet-cash-Details-clock_image mr-1"
														     style={{marginBottom: "3px"}}
														/>
														<ReactTimeAgo date={item.node.created} locale="en-US"/>
													</p>
												</div>
											</div>
										</Fade>
									</div>
								);
							}) : <div className={"container error-section"}>No Datas Found</div>

						}
					</div>
					{/*<div className={"wallet-bottom-nav"}>*/}
					{/*	<BottomNav/>*/}
					{/*</div>*/}
					{/*<hr className="line_tag"/>*/}

				</div>
			</Loading>
		);
	}
}

export default withRouter(WalletHistory)
